import { useLanguage } from "@/context/LanguageContext";
import { buildWaLink } from "@/lib/whatsapp";

const WhatsAppFloat = () => {
  const { t } = useLanguage();
  return (
    <a
      href={buildWaLink(t("whatsapp.msg_default"))}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 end-6 z-50 h-16 w-16 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_12px_40px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
      aria-label={t("whatsapp.cta_label")}
    >
      <svg viewBox="0 0 32 32" width="30" height="30" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.28c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.35-1.6-1.5-1.87-.16-.27-.02-.42.12-.55.12-.12.27-.32.4-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.02-.22-.53-.45-.46-.61-.47-.16-.01-.34-.01-.53-.01s-.48.07-.73.34c-.25.27-.96.94-.96 2.29 0 1.35.98 2.65 1.12 2.83.14.18 1.94 2.96 4.71 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32zM16 4C9.37 4 4 9.37 4 16c0 2.11.55 4.09 1.52 5.82L4 28l6.35-1.66A11.94 11.94 0 0 0 16 28c6.63 0 12-5.37 12-12S22.63 4 16 4z" />
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
